var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "rp-cart-container rp-modal",
        class: { "is-active": _vm.isActive }
      },
      [
        _c("div", { staticClass: "rp-modal-background" }),
        _vm._v(" "),
        _c("div", { staticClass: "rp-modal-content" }, [
          _c("div", { staticClass: "rp-container-modal" }, [
            _c(
              "a",
              {
                staticClass: "close-popup-policy",
                on: { click: _vm.closeCart }
              },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "rp-content-modal",
                attrs: { id: "rp-content-modal" }
              },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.defaultPolicy) }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rp-icon" }, [
      _c("i", { staticClass: "fa fa-times" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9759bb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9759bb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/policyPopup/PolicyPopup.vue
// module id = null
// module chunks = 